/* tslint:disable */
/* eslint-disable */
/**
 * Landvoice Internal API
 * API backing the Landvoice site.
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'house_number': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'street_name': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'street_predirection'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'street_postdirection'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'street_suffix'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'unit'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'legal_unit'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'postal_code_plus4'?: string;
}
/**
 * Enum for ApplicationType.
 * @export
 * @enum {number}
 */

export const ApplicationType = {
    NUMBER_1: 1
} as const;

export type ApplicationType = typeof ApplicationType[keyof typeof ApplicationType];


/**
 * 
 * @export
 * @interface Circle
 */
export interface Circle {
    /**
     * 
     * @type {Point}
     * @memberof Circle
     */
    'center': Point;
    /**
     * 
     * @type {number}
     * @memberof Circle
     */
    'radius': number;
}
/**
 * 
 * @export
 * @interface Contact
 */
export interface Contact {
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'middle_name': string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'full_name': string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'phone_number': string;
    /**
     * 
     * @type {PhoneType}
     * @memberof Contact
     */
    'phone_type': PhoneType;
    /**
     * 
     * @type {boolean}
     * @memberof Contact
     */
    'do_not_call': boolean;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'email'?: string;
    /**
     * 
     * @type {number}
     * @memberof Contact
     */
    'age'?: number;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'gender'?: string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'income'?: string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'marital_status'?: string;
    /**
     * 
     * @type {number}
     * @memberof Contact
     */
    'number_of_children'?: number;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'education'?: string;
    /**
     * 
     * @type {HomeValueRange}
     * @memberof Contact
     */
    'home_value_range'?: HomeValueRange;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'net_worth'?: string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'occupation'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Contact
     */
    'business_owner'?: boolean;
    /**
     * 
     * @type {Array<SocialMedia>}
     * @memberof Contact
     */
    'social_media'?: Array<SocialMedia>;
}


/**
 * 
 * @export
 * @interface ContactInfo
 */
export interface ContactInfo {
    /**
     * 
     * @type {Array<Contact>}
     * @memberof ContactInfo
     */
    'contacts': Array<Contact>;
    /**
     * 
     * @type {Property}
     * @memberof ContactInfo
     */
    'mailing_address'?: Property;
}
/**
 * Credits for a user per application.
 * @export
 * @interface Credits
 */
export interface Credits {
    /**
     * 
     * @type {number}
     * @memberof Credits
     */
    'paid_credits': number;
    /**
     * 
     * @type {number}
     * @memberof Credits
     */
    'nonpaid_credits': number;
    /**
     * 
     * @type {string}
     * @memberof Credits
     */
    'application': string;
}
/**
 * A user may add or remove a favorite property.
 * @export
 * @interface Favorite
 */
export interface Favorite {
    /**
     * 
     * @type {string}
     * @memberof Favorite
     */
    'property_id': string;
    /**
     * 
     * @type {string}
     * @memberof Favorite
     */
    'create_timestamp'?: string;
}
/**
 * 
 * @export
 * @interface GeoLocation
 */
export interface GeoLocation {
    /**
     * 
     * @type {number}
     * @memberof GeoLocation
     */
    'latitude': number;
    /**
     * 
     * @type {number}
     * @memberof GeoLocation
     */
    'longitude': number;
    /**
     * 
     * @type {string}
     * @memberof GeoLocation
     */
    'accuracy': string;
}
/**
 * Input model for previewing a search.
 * @export
 * @interface GeoRequest
 */
export interface GeoRequest {
    /**
     * 
     * @type {Polygon}
     * @memberof GeoRequest
     */
    'polygon'?: Polygon;
    /**
     * 
     * @type {Circle}
     * @memberof GeoRequest
     */
    'circle'?: Circle;
    /**
     * 
     * @type {Array<Polygon>}
     * @memberof GeoRequest
     */
    'exclude_polygon'?: Array<Polygon>;
}
/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * 
 * @export
 * @interface HomeValueRange
 */
export interface HomeValueRange {
    /**
     * 
     * @type {number}
     * @memberof HomeValueRange
     */
    'start'?: number;
    /**
     * 
     * @type {number}
     * @memberof HomeValueRange
     */
    'end'?: number;
}
/**
 * A lead represents a property and source. It may have contact info based on the permissions of a user.
 * @export
 * @interface Lead
 */
export interface Lead {
    /**
     * 
     * @type {string}
     * @memberof Lead
     */
    'id': string;
    /**
     * 
     * @type {LeadType}
     * @memberof Lead
     */
    'lead_type': LeadType;
    /**
     * 
     * @type {string}
     * @memberof Lead
     */
    'create_timestamp': string;
    /**
     * 
     * @type {PropertyInfo}
     * @memberof Lead
     */
    'property_info': PropertyInfo;
    /**
     * 
     * @type {ContactInfo}
     * @memberof Lead
     */
    'contact_info'?: ContactInfo;
    /**
     * 
     * @type {boolean}
     * @memberof Lead
     */
    'hidden'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof Lead
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof Lead
     */
    'favorite'?: boolean;
    /**
     * 
     * @type {Array<Note>}
     * @memberof Lead
     */
    'notes'?: Array<Note>;
}


/**
 * Lists a user may use to organize leads.
 * @export
 * @interface LeadList
 */
export interface LeadList {
    /**
     * 
     * @type {string}
     * @memberof LeadList
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadList
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadList
     */
    'create_timestamp'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LeadList
     */
    'hidden'?: boolean;
    /**
     * 
     * @type {object}
     * @memberof LeadList
     */
    'search_parameters'?: object;
    /**
     * 
     * @type {number}
     * @memberof LeadList
     */
    'result_count'?: number;
    /**
     * 
     * @type {LookupStatus}
     * @memberof LeadList
     */
    'lookup_status'?: LookupStatus;
}


/**
 * List of UUIDs.
 * @export
 * @interface LeadListIDS
 */
export interface LeadListIDS {
    /**
     * 
     * @type {Array<string>}
     * @memberof LeadListIDS
     */
    'list_ids': Array<string>;
}
/**
 * Response for the lead-list endpoint count of records
 * @export
 * @interface LeadListResponse
 */
export interface LeadListResponse {
    /**
     * 
     * @type {Array<LeadList>}
     * @memberof LeadListResponse
     */
    'lists': Array<LeadList>;
    /**
     * 
     * @type {number}
     * @memberof LeadListResponse
     */
    'total_count': number;
}
/**
 * A patch request for the Lead.    
 * @export
 * @interface LeadRequest
 */
export interface LeadRequest {
    /**
     * 
     * @type {boolean}
     * @memberof LeadRequest
     */
    'hidden'?: boolean;
}
/**
 * Leads with total counts
 * @export
 * @interface LeadResponse
 */
export interface LeadResponse {
    /**
     * 
     * @type {Array<Lead>}
     * @memberof LeadResponse
     */
    'leads': Array<Lead>;
    /**
     * 
     * @type {number}
     * @memberof LeadResponse
     */
    'total_count': number;
}
/**
 * Source of the lead
 * @export
 * @enum {string}
 */

export const LeadType = {
    N: 'N',
    E: 'E',
    F: 'F',
    P: 'P'
} as const;

export type LeadType = typeof LeadType[keyof typeof LeadType];


/**
 * Model to describe a limit.
 * @export
 * @interface Limit
 */
export interface Limit {
    /**
     * 
     * @type {number}
     * @memberof Limit
     */
    'used': number;
    /**
     * 
     * @type {number}
     * @memberof Limit
     */
    'max'?: number;
}
/**
 * 
 * @export
 * @interface LocationInner
 */
export interface LocationInner {
}
/**
 * Model returned for status of a job request.
 * @export
 * @interface LookupResponse
 */
export interface LookupResponse {
    /**
     * 
     * @type {string}
     * @memberof LookupResponse
     */
    'job_id': string;
    /**
     * 
     * @type {LookupStatus}
     * @memberof LookupResponse
     */
    'lookup_status'?: LookupStatus;
    /**
     * 
     * @type {string}
     * @memberof LookupResponse
     */
    'status_timestamp'?: string;
}


/**
 * Enum describing the status of a lookup.
 * @export
 * @enum {string}
 */

export const LookupStatus = {
    C: 'C',
    Q: 'Q',
    I: 'I',
    F: 'F'
} as const;

export type LookupStatus = typeof LookupStatus[keyof typeof LookupStatus];


/**
 * 
 * @export
 * @interface Message
 */
export interface Message {
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    'message': string;
}
/**
 * A note a user may leave on a property.
 * @export
 * @interface Note
 */
export interface Note {
    /**
     * 
     * @type {string}
     * @memberof Note
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Note
     */
    'note': string;
    /**
     * 
     * @type {string}
     * @memberof Note
     */
    'modify_timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof Note
     */
    'create_timestamp'?: string;
}
/**
 * 
 * @export
 * @interface Owner
 */
export interface Owner {
    /**
     * 
     * @type {string}
     * @memberof Owner
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof Owner
     */
    'middle_name': string;
    /**
     * 
     * @type {string}
     * @memberof Owner
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof Owner
     */
    'full_name': string;
    /**
     * 
     * @type {number}
     * @memberof Owner
     */
    'order': number;
}
/**
 * 
 * @export
 * @interface OwnerInfo
 */
export interface OwnerInfo {
    /**
     * 
     * @type {Array<Owner>}
     * @memberof OwnerInfo
     */
    'party_owners': Array<Owner>;
    /**
     * 
     * @type {Array<Owner>}
     * @memberof OwnerInfo
     */
    'deed_owners': Array<Owner>;
    /**
     * 
     * @type {string}
     * @memberof OwnerInfo
     */
    'owner1_owner2_relationship'?: string;
    /**
     * 
     * @type {string}
     * @memberof OwnerInfo
     */
    'owner3_owner4_relationship'?: string;
    /**
     * 
     * @type {Property}
     * @memberof OwnerInfo
     */
    'mailing_address'?: Property;
    /**
     * 
     * @type {boolean}
     * @memberof OwnerInfo
     */
    'owner_occupied'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OwnerInfo
     */
    'vacant'?: boolean;
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const PhoneType = {
    H: 'H',
    M: 'M',
    B: 'B',
    O: 'O'
} as const;

export type PhoneType = typeof PhoneType[keyof typeof PhoneType];


/**
 * 
 * @export
 * @interface Point
 */
export interface Point {
    /**
     * 
     * @type {number}
     * @memberof Point
     */
    'latitude': number;
    /**
     * 
     * @type {number}
     * @memberof Point
     */
    'longitude': number;
}
/**
 * 
 * @export
 * @interface Polygon
 */
export interface Polygon {
    /**
     * 
     * @type {Array<Point>}
     * @memberof Polygon
     */
    'points': Array<Point>;
}
/**
 * Model for describing a property in the preview view.
 * @export
 * @interface PreviewItem
 */
export interface PreviewItem {
    /**
     * 
     * @type {string}
     * @memberof PreviewItem
     */
    'id': string;
    /**
     * 
     * @type {GeoLocation}
     * @memberof PreviewItem
     */
    'geolocation': GeoLocation;
}
/**
 * Model returned from a preview request.
 * @export
 * @interface PreviewResponse
 */
export interface PreviewResponse {
    /**
     * 
     * @type {Array<PreviewItem>}
     * @memberof PreviewResponse
     */
    'properties': Array<PreviewItem>;
    /**
     * 
     * @type {number}
     * @memberof PreviewResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface Property
 */
export interface Property {
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    'house_number': string;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    'street_name': string;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    'street_predirection'?: string;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    'street_postdirection'?: string;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    'street_suffix'?: string;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    'unit'?: string;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    'legal_unit'?: string;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    'postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    'postal_code_plus4'?: string;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    'id': string;
    /**
     * 
     * @type {GeoLocation}
     * @memberof Property
     */
    'geolocation': GeoLocation;
}
/**
 * 
 * @export
 * @interface PropertyDetails
 */
export interface PropertyDetails {
    /**
     * 
     * @type {PropertyType}
     * @memberof PropertyDetails
     */
    'property_type': PropertyType;
    /**
     * 
     * @type {boolean}
     * @memberof PropertyDetails
     */
    'company_owned'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PropertyDetails
     */
    'bedrooms'?: number;
    /**
     * 
     * @type {number}
     * @memberof PropertyDetails
     */
    'bathrooms'?: number;
    /**
     * 
     * @type {number}
     * @memberof PropertyDetails
     */
    'partial_bathrooms'?: number;
    /**
     * 
     * @type {number}
     * @memberof PropertyDetails
     */
    'square_footage'?: number;
    /**
     * 
     * @type {number}
     * @memberof PropertyDetails
     */
    'acreage'?: number;
    /**
     * 
     * @type {number}
     * @memberof PropertyDetails
     */
    'year_built'?: number;
}


/**
 * 
 * @export
 * @interface PropertyInfo
 */
export interface PropertyInfo {
    /**
     * 
     * @type {string}
     * @memberof PropertyInfo
     */
    'house_number': string;
    /**
     * 
     * @type {string}
     * @memberof PropertyInfo
     */
    'street_name': string;
    /**
     * 
     * @type {string}
     * @memberof PropertyInfo
     */
    'street_predirection'?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyInfo
     */
    'street_postdirection'?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyInfo
     */
    'street_suffix'?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyInfo
     */
    'unit'?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyInfo
     */
    'legal_unit'?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyInfo
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof PropertyInfo
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof PropertyInfo
     */
    'postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyInfo
     */
    'postal_code_plus4'?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyInfo
     */
    'id': string;
    /**
     * 
     * @type {GeoLocation}
     * @memberof PropertyInfo
     */
    'geolocation': GeoLocation;
    /**
     * 
     * @type {PropertyDetails}
     * @memberof PropertyInfo
     */
    'details'?: PropertyDetails;
    /**
     * 
     * @type {OwnerInfo}
     * @memberof PropertyInfo
     */
    'owner_info'?: OwnerInfo;
    /**
     * 
     * @type {TaxInfo}
     * @memberof PropertyInfo
     */
    'tax_info'?: TaxInfo;
}
/**
 * 
 * @export
 * @interface PropertyReport
 */
export interface PropertyReport {
    /**
     * 
     * @type {string}
     * @memberof PropertyReport
     */
    'property_id'?: string;
    /**
     * 
     * @type {ReportTypeEnum}
     * @memberof PropertyReport
     */
    'report_type': ReportTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PropertyReport
     */
    'comment': string;
}


/**
 * 
 * @export
 * @interface PropertyReportDb
 */
export interface PropertyReportDb {
    /**
     * 
     * @type {string}
     * @memberof PropertyReportDb
     */
    'property_id'?: string;
    /**
     * 
     * @type {ReportTypeEnum}
     * @memberof PropertyReportDb
     */
    'report_type': ReportTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PropertyReportDb
     */
    'comment': string;
    /**
     * 
     * @type {number}
     * @memberof PropertyReportDb
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PropertyReportDb
     */
    'create_timestamp': string;
}


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const PropertyType = {
    C: 'C',
    L: 'L',
    I: 'I',
    M: 'M',
    B: 'B',
    S: 'S',
    P: 'P',
    O: 'O',
    T: 'T'
} as const;

export type PropertyType = typeof PropertyType[keyof typeof PropertyType];


/**
 * Model to represent a user\'s quotas.
 * @export
 * @interface Quota
 */
export interface Quota {
    /**
     * 
     * @type {Limit}
     * @memberof Quota
     */
    'monthly': Limit;
    /**
     * 
     * @type {Limit}
     * @memberof Quota
     */
    'lifetime': Limit;
}
/**
 * Model to represent a user\'s quota per application.
 * @export
 * @interface QuotaApp
 */
export interface QuotaApp {
    /**
     * 
     * @type {ApplicationType}
     * @memberof QuotaApp
     */
    'application': ApplicationType;
    /**
     * 
     * @type {Quota}
     * @memberof QuotaApp
     */
    'quota': Quota;
}


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const ReportTypeEnum = {
    MissingProperty: 'missing_property',
    IncorrentOwner: 'incorrent_owner',
    IncorrectPhone: 'incorrect_phone',
    Other: 'other'
} as const;

export type ReportTypeEnum = typeof ReportTypeEnum[keyof typeof ReportTypeEnum];


/**
 * Model for submitting an address lookup
 * @export
 * @interface ReverseAddressRequest
 */
export interface ReverseAddressRequest {
    /**
     * 
     * @type {Array<Address>}
     * @memberof ReverseAddressRequest
     */
    'addresses': Array<Address>;
}
/**
 * Model for submitting a phone lookup
 * @export
 * @interface ReversePhoneRequest
 */
export interface ReversePhoneRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ReversePhoneRequest
     */
    'phones': Array<string>;
}
/**
 * 
 * @export
 * @interface SocialMedia
 */
export interface SocialMedia {
    /**
     * 
     * @type {string}
     * @memberof SocialMedia
     */
    'network': string;
    /**
     * 
     * @type {string}
     * @memberof SocialMedia
     */
    'username': string;
}
/**
 * A user may add or remove a Tag for a property.
 * @export
 * @interface Tag
 */
export interface Tag {
    /**
     * 
     * @type {string}
     * @memberof Tag
     */
    'property_id': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Tag
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Tag
     */
    'create_timestamp'?: string;
}
/**
 * 
 * @export
 * @interface TaxInfo
 */
export interface TaxInfo {
    /**
     * 
     * @type {string}
     * @memberof TaxInfo
     */
    'last_sale_date'?: string;
    /**
     * 
     * @type {number}
     * @memberof TaxInfo
     */
    'last_sale_price'?: number;
}
/**
 * UserSubscriptionLevel object.  object which represents the user\'s subscription level, intended to be used as a response model.
 * @export
 * @interface UserSubscriptionLevel
 */
export interface UserSubscriptionLevel {
    /**
     * 
     * @type {UserSubscriptionLevelEnum}
     * @memberof UserSubscriptionLevel
     */
    'subscription_level': UserSubscriptionLevelEnum;
    /**
     * 
     * @type {string}
     * @memberof UserSubscriptionLevel
     */
    'timestamp': string;
}


/**
 * Enum for Subscription Level.
 * @export
 * @enum {string}
 */

export const UserSubscriptionLevelEnum = {
    Trial: 'trial',
    Basic: 'basic'
} as const;

export type UserSubscriptionLevelEnum = typeof UserSubscriptionLevelEnum[keyof typeof UserSubscriptionLevelEnum];


/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<LocationInner>}
     * @memberof ValidationError
     */
    'loc': Array<LocationInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}

/**
 * CombineListOfLeadsApi - axios parameter creator
 * @export
 */
export const CombineListOfLeadsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Display all leads associated with the LeadList.
         * @summary Combine List Of Leads
         * @param {LeadListIDS} leadListIDS 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        combineListOfLeads: async (leadListIDS: LeadListIDS, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'leadListIDS' is not null or undefined
            assertParamExists('combineListOfLeads', 'leadListIDS', leadListIDS)
            const localVarPath = `/v2/lead-lists/combine-lead-list/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(leadListIDS, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CombineListOfLeadsApi - functional programming interface
 * @export
 */
export const CombineListOfLeadsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CombineListOfLeadsApiAxiosParamCreator(configuration)
    return {
        /**
         * Display all leads associated with the LeadList.
         * @summary Combine List Of Leads
         * @param {LeadListIDS} leadListIDS 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async combineListOfLeads(leadListIDS: LeadListIDS, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeadList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.combineListOfLeads(leadListIDS, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CombineListOfLeadsApi.combineListOfLeads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CombineListOfLeadsApi - factory interface
 * @export
 */
export const CombineListOfLeadsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CombineListOfLeadsApiFp(configuration)
    return {
        /**
         * Display all leads associated with the LeadList.
         * @summary Combine List Of Leads
         * @param {LeadListIDS} leadListIDS 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        combineListOfLeads(leadListIDS: LeadListIDS, options?: RawAxiosRequestConfig): AxiosPromise<LeadList> {
            return localVarFp.combineListOfLeads(leadListIDS, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CombineListOfLeadsApi - object-oriented interface
 * @export
 * @class CombineListOfLeadsApi
 * @extends {BaseAPI}
 */
export class CombineListOfLeadsApi extends BaseAPI {
    /**
     * Display all leads associated with the LeadList.
     * @summary Combine List Of Leads
     * @param {LeadListIDS} leadListIDS 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CombineListOfLeadsApi
     */
    public combineListOfLeads(leadListIDS: LeadListIDS, options?: RawAxiosRequestConfig) {
        return CombineListOfLeadsApiFp(this.configuration).combineListOfLeads(leadListIDS, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Root path response to allow AWS load balancer health checks.
         * @summary Default Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        defaultPageGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckHealthzGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/healthz`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Root path response to allow AWS load balancer health checks.
         * @summary Default Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async defaultPageGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.defaultPageGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.defaultPageGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthCheckHealthzGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheckHealthzGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.healthCheckHealthzGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Root path response to allow AWS load balancer health checks.
         * @summary Default Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        defaultPageGet(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.defaultPageGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckHealthzGet(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.healthCheckHealthzGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Root path response to allow AWS load balancer health checks.
     * @summary Default Page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public defaultPageGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).defaultPageGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Health Check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public healthCheckHealthzGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).healthCheckHealthzGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DevelopmentApi - axios parameter creator
 * @export
 */
export const DevelopmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Show credit information for the current user.
         * @summary Get Credits
         * @param {string} [serviceAddr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCredits: async (serviceAddr?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/credits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required

            if (serviceAddr !== undefined) {
                localVarQueryParameter['service_addr'] = serviceAddr;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the history of a property\'s ownership.
         * @summary Get Owner History
         * @param {string} propId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnerHistory: async (propId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propId' is not null or undefined
            assertParamExists('getOwnerHistory', 'propId', propId)
            const localVarPath = `/v2/properties/{prop_id}/owner_history`
                .replace(`{${"prop_id"}}`, encodeURIComponent(String(propId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submit one or more phone numbers for lookup.
         * @summary Submit Reverse Phone
         * @param {ReversePhoneRequest} reversePhoneRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitReversePhone: async (reversePhoneRequest: ReversePhoneRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reversePhoneRequest' is not null or undefined
            assertParamExists('submitReversePhone', 'reversePhoneRequest', reversePhoneRequest)
            const localVarPath = `/v2/reverse-address/reverse-phone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reversePhoneRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DevelopmentApi - functional programming interface
 * @export
 */
export const DevelopmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DevelopmentApiAxiosParamCreator(configuration)
    return {
        /**
         * Show credit information for the current user.
         * @summary Get Credits
         * @param {string} [serviceAddr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCredits(serviceAddr?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Credits>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCredits(serviceAddr, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentApi.getCredits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the history of a property\'s ownership.
         * @summary Get Owner History
         * @param {string} propId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOwnerHistory(propId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Owner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOwnerHistory(propId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentApi.getOwnerHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Submit one or more phone numbers for lookup.
         * @summary Submit Reverse Phone
         * @param {ReversePhoneRequest} reversePhoneRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitReversePhone(reversePhoneRequest: ReversePhoneRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeadList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitReversePhone(reversePhoneRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentApi.submitReversePhone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DevelopmentApi - factory interface
 * @export
 */
export const DevelopmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DevelopmentApiFp(configuration)
    return {
        /**
         * Show credit information for the current user.
         * @summary Get Credits
         * @param {string} [serviceAddr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCredits(serviceAddr?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Credits>> {
            return localVarFp.getCredits(serviceAddr, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the history of a property\'s ownership.
         * @summary Get Owner History
         * @param {string} propId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnerHistory(propId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Owner>> {
            return localVarFp.getOwnerHistory(propId, options).then((request) => request(axios, basePath));
        },
        /**
         * Submit one or more phone numbers for lookup.
         * @summary Submit Reverse Phone
         * @param {ReversePhoneRequest} reversePhoneRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitReversePhone(reversePhoneRequest: ReversePhoneRequest, options?: RawAxiosRequestConfig): AxiosPromise<LeadList> {
            return localVarFp.submitReversePhone(reversePhoneRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DevelopmentApi - object-oriented interface
 * @export
 * @class DevelopmentApi
 * @extends {BaseAPI}
 */
export class DevelopmentApi extends BaseAPI {
    /**
     * Show credit information for the current user.
     * @summary Get Credits
     * @param {string} [serviceAddr] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentApi
     */
    public getCredits(serviceAddr?: string, options?: RawAxiosRequestConfig) {
        return DevelopmentApiFp(this.configuration).getCredits(serviceAddr, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the history of a property\'s ownership.
     * @summary Get Owner History
     * @param {string} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentApi
     */
    public getOwnerHistory(propId: string, options?: RawAxiosRequestConfig) {
        return DevelopmentApiFp(this.configuration).getOwnerHistory(propId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Submit one or more phone numbers for lookup.
     * @summary Submit Reverse Phone
     * @param {ReversePhoneRequest} reversePhoneRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentApi
     */
    public submitReversePhone(reversePhoneRequest: ReversePhoneRequest, options?: RawAxiosRequestConfig) {
        return DevelopmentApiFp(this.configuration).submitReversePhone(reversePhoneRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GeosearchApi - axios parameter creator
 * @export
 */
export const GeosearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Return a LeadList summarizing a geosearch lookup.  Request a lookup of properties that satisfy the search parameters, compare the property count to available user quota, and construct and return a LeadList object describing the geosearch lookup.
         * @summary Geosearch
         * @param {GeoRequest} geoRequest 
         * @param {Array<string>} [bedrooms] Filter bedrooms by exact count or range.
         * @param {Array<string>} [bathrooms] Filter bathrooms by minimum count inclusive.
         * @param {Array<string>} [acreage] Filter acreage by exact size or range.
         * @param {Array<string>} [squareFootage] Filter square footage by exact size or range.
         * @param {Array<string>} [yearBuilt] Filter year built by exact year or range.
         * @param {Array<string>} [propertyType] Filter by property types. Can be passed multiple times.
         * @param {boolean} [companyOwned] Filter by weather the property is owned by a company.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geosearch: async (geoRequest: GeoRequest, bedrooms?: Array<string>, bathrooms?: Array<string>, acreage?: Array<string>, squareFootage?: Array<string>, yearBuilt?: Array<string>, propertyType?: Array<string>, companyOwned?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'geoRequest' is not null or undefined
            assertParamExists('geosearch', 'geoRequest', geoRequest)
            const localVarPath = `/v2/geosearch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required

            if (bedrooms) {
                localVarQueryParameter['bedrooms'] = bedrooms;
            }

            if (bathrooms) {
                localVarQueryParameter['bathrooms'] = bathrooms;
            }

            if (acreage) {
                localVarQueryParameter['acreage'] = acreage;
            }

            if (squareFootage) {
                localVarQueryParameter['square_footage'] = squareFootage;
            }

            if (yearBuilt) {
                localVarQueryParameter['year_built'] = yearBuilt;
            }

            if (propertyType) {
                localVarQueryParameter['property_type'] = propertyType;
            }

            if (companyOwned !== undefined) {
                localVarQueryParameter['company_owned'] = companyOwned;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(geoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate a preview of the properties that will be returned according to the search parameters.
         * @summary Geosearch Preview
         * @param {GeoRequest} geoRequest 
         * @param {Array<string>} [bedrooms] Filter bedrooms by exact count or range.
         * @param {Array<string>} [bathrooms] Filter bathrooms by minimum count inclusive.
         * @param {Array<string>} [acreage] Filter acreage by exact size or range.
         * @param {Array<string>} [squareFootage] Filter square footage by exact size or range.
         * @param {Array<string>} [yearBuilt] Filter year built by exact year or range.
         * @param {Array<string>} [propertyType] Filter by property types. Can be passed multiple times.
         * @param {boolean} [companyOwned] Filter by weather the property is owned by a company.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geosearchPreview: async (geoRequest: GeoRequest, bedrooms?: Array<string>, bathrooms?: Array<string>, acreage?: Array<string>, squareFootage?: Array<string>, yearBuilt?: Array<string>, propertyType?: Array<string>, companyOwned?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'geoRequest' is not null or undefined
            assertParamExists('geosearchPreview', 'geoRequest', geoRequest)
            const localVarPath = `/v2/geosearch/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required

            if (bedrooms) {
                localVarQueryParameter['bedrooms'] = bedrooms;
            }

            if (bathrooms) {
                localVarQueryParameter['bathrooms'] = bathrooms;
            }

            if (acreage) {
                localVarQueryParameter['acreage'] = acreage;
            }

            if (squareFootage) {
                localVarQueryParameter['square_footage'] = squareFootage;
            }

            if (yearBuilt) {
                localVarQueryParameter['year_built'] = yearBuilt;
            }

            if (propertyType) {
                localVarQueryParameter['property_type'] = propertyType;
            }

            if (companyOwned !== undefined) {
                localVarQueryParameter['company_owned'] = companyOwned;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(geoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeosearchApi - functional programming interface
 * @export
 */
export const GeosearchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GeosearchApiAxiosParamCreator(configuration)
    return {
        /**
         * Return a LeadList summarizing a geosearch lookup.  Request a lookup of properties that satisfy the search parameters, compare the property count to available user quota, and construct and return a LeadList object describing the geosearch lookup.
         * @summary Geosearch
         * @param {GeoRequest} geoRequest 
         * @param {Array<string>} [bedrooms] Filter bedrooms by exact count or range.
         * @param {Array<string>} [bathrooms] Filter bathrooms by minimum count inclusive.
         * @param {Array<string>} [acreage] Filter acreage by exact size or range.
         * @param {Array<string>} [squareFootage] Filter square footage by exact size or range.
         * @param {Array<string>} [yearBuilt] Filter year built by exact year or range.
         * @param {Array<string>} [propertyType] Filter by property types. Can be passed multiple times.
         * @param {boolean} [companyOwned] Filter by weather the property is owned by a company.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async geosearch(geoRequest: GeoRequest, bedrooms?: Array<string>, bathrooms?: Array<string>, acreage?: Array<string>, squareFootage?: Array<string>, yearBuilt?: Array<string>, propertyType?: Array<string>, companyOwned?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeadList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.geosearch(geoRequest, bedrooms, bathrooms, acreage, squareFootage, yearBuilt, propertyType, companyOwned, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeosearchApi.geosearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate a preview of the properties that will be returned according to the search parameters.
         * @summary Geosearch Preview
         * @param {GeoRequest} geoRequest 
         * @param {Array<string>} [bedrooms] Filter bedrooms by exact count or range.
         * @param {Array<string>} [bathrooms] Filter bathrooms by minimum count inclusive.
         * @param {Array<string>} [acreage] Filter acreage by exact size or range.
         * @param {Array<string>} [squareFootage] Filter square footage by exact size or range.
         * @param {Array<string>} [yearBuilt] Filter year built by exact year or range.
         * @param {Array<string>} [propertyType] Filter by property types. Can be passed multiple times.
         * @param {boolean} [companyOwned] Filter by weather the property is owned by a company.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async geosearchPreview(geoRequest: GeoRequest, bedrooms?: Array<string>, bathrooms?: Array<string>, acreage?: Array<string>, squareFootage?: Array<string>, yearBuilt?: Array<string>, propertyType?: Array<string>, companyOwned?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.geosearchPreview(geoRequest, bedrooms, bathrooms, acreage, squareFootage, yearBuilt, propertyType, companyOwned, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeosearchApi.geosearchPreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GeosearchApi - factory interface
 * @export
 */
export const GeosearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GeosearchApiFp(configuration)
    return {
        /**
         * Return a LeadList summarizing a geosearch lookup.  Request a lookup of properties that satisfy the search parameters, compare the property count to available user quota, and construct and return a LeadList object describing the geosearch lookup.
         * @summary Geosearch
         * @param {GeoRequest} geoRequest 
         * @param {Array<string>} [bedrooms] Filter bedrooms by exact count or range.
         * @param {Array<string>} [bathrooms] Filter bathrooms by minimum count inclusive.
         * @param {Array<string>} [acreage] Filter acreage by exact size or range.
         * @param {Array<string>} [squareFootage] Filter square footage by exact size or range.
         * @param {Array<string>} [yearBuilt] Filter year built by exact year or range.
         * @param {Array<string>} [propertyType] Filter by property types. Can be passed multiple times.
         * @param {boolean} [companyOwned] Filter by weather the property is owned by a company.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geosearch(geoRequest: GeoRequest, bedrooms?: Array<string>, bathrooms?: Array<string>, acreage?: Array<string>, squareFootage?: Array<string>, yearBuilt?: Array<string>, propertyType?: Array<string>, companyOwned?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<LeadList> {
            return localVarFp.geosearch(geoRequest, bedrooms, bathrooms, acreage, squareFootage, yearBuilt, propertyType, companyOwned, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate a preview of the properties that will be returned according to the search parameters.
         * @summary Geosearch Preview
         * @param {GeoRequest} geoRequest 
         * @param {Array<string>} [bedrooms] Filter bedrooms by exact count or range.
         * @param {Array<string>} [bathrooms] Filter bathrooms by minimum count inclusive.
         * @param {Array<string>} [acreage] Filter acreage by exact size or range.
         * @param {Array<string>} [squareFootage] Filter square footage by exact size or range.
         * @param {Array<string>} [yearBuilt] Filter year built by exact year or range.
         * @param {Array<string>} [propertyType] Filter by property types. Can be passed multiple times.
         * @param {boolean} [companyOwned] Filter by weather the property is owned by a company.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geosearchPreview(geoRequest: GeoRequest, bedrooms?: Array<string>, bathrooms?: Array<string>, acreage?: Array<string>, squareFootage?: Array<string>, yearBuilt?: Array<string>, propertyType?: Array<string>, companyOwned?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PreviewResponse> {
            return localVarFp.geosearchPreview(geoRequest, bedrooms, bathrooms, acreage, squareFootage, yearBuilt, propertyType, companyOwned, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GeosearchApi - object-oriented interface
 * @export
 * @class GeosearchApi
 * @extends {BaseAPI}
 */
export class GeosearchApi extends BaseAPI {
    /**
     * Return a LeadList summarizing a geosearch lookup.  Request a lookup of properties that satisfy the search parameters, compare the property count to available user quota, and construct and return a LeadList object describing the geosearch lookup.
     * @summary Geosearch
     * @param {GeoRequest} geoRequest 
     * @param {Array<string>} [bedrooms] Filter bedrooms by exact count or range.
     * @param {Array<string>} [bathrooms] Filter bathrooms by minimum count inclusive.
     * @param {Array<string>} [acreage] Filter acreage by exact size or range.
     * @param {Array<string>} [squareFootage] Filter square footage by exact size or range.
     * @param {Array<string>} [yearBuilt] Filter year built by exact year or range.
     * @param {Array<string>} [propertyType] Filter by property types. Can be passed multiple times.
     * @param {boolean} [companyOwned] Filter by weather the property is owned by a company.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeosearchApi
     */
    public geosearch(geoRequest: GeoRequest, bedrooms?: Array<string>, bathrooms?: Array<string>, acreage?: Array<string>, squareFootage?: Array<string>, yearBuilt?: Array<string>, propertyType?: Array<string>, companyOwned?: boolean, options?: RawAxiosRequestConfig) {
        return GeosearchApiFp(this.configuration).geosearch(geoRequest, bedrooms, bathrooms, acreage, squareFootage, yearBuilt, propertyType, companyOwned, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate a preview of the properties that will be returned according to the search parameters.
     * @summary Geosearch Preview
     * @param {GeoRequest} geoRequest 
     * @param {Array<string>} [bedrooms] Filter bedrooms by exact count or range.
     * @param {Array<string>} [bathrooms] Filter bathrooms by minimum count inclusive.
     * @param {Array<string>} [acreage] Filter acreage by exact size or range.
     * @param {Array<string>} [squareFootage] Filter square footage by exact size or range.
     * @param {Array<string>} [yearBuilt] Filter year built by exact year or range.
     * @param {Array<string>} [propertyType] Filter by property types. Can be passed multiple times.
     * @param {boolean} [companyOwned] Filter by weather the property is owned by a company.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeosearchApi
     */
    public geosearchPreview(geoRequest: GeoRequest, bedrooms?: Array<string>, bathrooms?: Array<string>, acreage?: Array<string>, squareFootage?: Array<string>, yearBuilt?: Array<string>, propertyType?: Array<string>, companyOwned?: boolean, options?: RawAxiosRequestConfig) {
        return GeosearchApiFp(this.configuration).geosearchPreview(geoRequest, bedrooms, bathrooms, acreage, squareFootage, yearBuilt, propertyType, companyOwned, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LeadListsApi - axios parameter creator
 * @export
 */
export const LeadListsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new LeadList.
         * @summary Create List
         * @param {LeadList} leadList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createList: async (leadList: LeadList, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'leadList' is not null or undefined
            assertParamExists('createList', 'leadList', leadList)
            const localVarPath = `/v2/lead-lists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(leadList, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a LeadList. This is a soft operation. Deleted LeadLists will be marked as hidden.  Note that if delete_list raises a LeadListNotFound exception, this means that no items were found that match the criteria to identify the item to delete.  In that case, this function will raise an exception with status 404.  If, within delete_list, an error occurs while deleting the item, an exception will be thrown with status 500.  If no error is thrown, and delete_list returns a number greater than 0, the delete succeeded, and status code 204 will be returned.  The return value from this function will be None.
         * @summary Delete List
         * @param {string} listId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteList: async (listId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listId' is not null or undefined
            assertParamExists('deleteList', 'listId', listId)
            const localVarPath = `/v2/lead-lists/{list_id}`
                .replace(`{${"list_id"}}`, encodeURIComponent(String(listId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the job status of the provided LeadList ID.
         * @summary Get Job Status
         * @param {string} listId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobStatus: async (listId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listId' is not null or undefined
            assertParamExists('getJobStatus', 'listId', listId)
            const localVarPath = `/v2/lead-lists/{list_id}/status`
                .replace(`{${"list_id"}}`, encodeURIComponent(String(listId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the LeadList object.
         * @summary Get List Obj
         * @param {string} listId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListObj: async (listId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listId' is not null or undefined
            assertParamExists('getListObj', 'listId', listId)
            const localVarPath = `/v2/lead-lists/{list_id}`
                .replace(`{${"list_id"}}`, encodeURIComponent(String(listId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Display all leads associated with the LeadList.
         * @summary Get List Of Leads
         * @param {string} listId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListOfLeads: async (listId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listId' is not null or undefined
            assertParamExists('getListOfLeads', 'listId', listId)
            const localVarPath = `/v2/lead-lists/{list_id}/leads`
                .replace(`{${"list_id"}}`, encodeURIComponent(String(listId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Display the current user\'s LeadLists.
         * @summary Get Lists
         * @param {boolean} [showHidden] Include hidden/deleted LeadLists in results
         * @param {boolean} [onlyHidden] Include only hidden/deleted LeadLists in results
         * @param {string} [search] Search for lists by name. Separate terms by a space
         * @param {number} [offset] Number of rows to skip before beginning to return rows
         * @param {number} [limit] Number of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLists: async (showHidden?: boolean, onlyHidden?: boolean, search?: string, offset?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/lead-lists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required

            if (showHidden !== undefined) {
                localVarQueryParameter['show_hidden'] = showHidden;
            }

            if (onlyHidden !== undefined) {
                localVarQueryParameter['only_hidden'] = onlyHidden;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Display the current user\'s LeadLists with total count.
         * @summary Get Lists With Count
         * @param {boolean} [showHidden] Include hidden/deleted LeadLists in results
         * @param {boolean} [onlyHidden] Include only hidden/deleted LeadLists in results
         * @param {string} [search] Search for lists by name. Separate terms by a space
         * @param {number} [offset] Number of rows to skip before beginning to return rows
         * @param {number} [limit] Number of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListsWithCount: async (showHidden?: boolean, onlyHidden?: boolean, search?: string, offset?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/lead-lists/with-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required

            if (showHidden !== undefined) {
                localVarQueryParameter['show_hidden'] = showHidden;
            }

            if (onlyHidden !== undefined) {
                localVarQueryParameter['only_hidden'] = onlyHidden;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a LeadList by sending only those fields to be changed.
         * @summary Patch List
         * @param {string} listId 
         * @param {LeadList} leadList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchList: async (listId: string, leadList: LeadList, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listId' is not null or undefined
            assertParamExists('patchList', 'listId', listId)
            // verify required parameter 'leadList' is not null or undefined
            assertParamExists('patchList', 'leadList', leadList)
            const localVarPath = `/v2/lead-lists/{list_id}`
                .replace(`{${"list_id"}}`, encodeURIComponent(String(listId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(leadList, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a LeadList by setting all values for the LeadList object.
         * @summary Update List
         * @param {string} listId 
         * @param {LeadList} leadList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateList: async (listId: string, leadList: LeadList, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listId' is not null or undefined
            assertParamExists('updateList', 'listId', listId)
            // verify required parameter 'leadList' is not null or undefined
            assertParamExists('updateList', 'leadList', leadList)
            const localVarPath = `/v2/lead-lists/{list_id}`
                .replace(`{${"list_id"}}`, encodeURIComponent(String(listId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(leadList, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LeadListsApi - functional programming interface
 * @export
 */
export const LeadListsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LeadListsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new LeadList.
         * @summary Create List
         * @param {LeadList} leadList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createList(leadList: LeadList, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeadList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createList(leadList, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadListsApi.createList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a LeadList. This is a soft operation. Deleted LeadLists will be marked as hidden.  Note that if delete_list raises a LeadListNotFound exception, this means that no items were found that match the criteria to identify the item to delete.  In that case, this function will raise an exception with status 404.  If, within delete_list, an error occurs while deleting the item, an exception will be thrown with status 500.  If no error is thrown, and delete_list returns a number greater than 0, the delete succeeded, and status code 204 will be returned.  The return value from this function will be None.
         * @summary Delete List
         * @param {string} listId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteList(listId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteList(listId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadListsApi.deleteList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the job status of the provided LeadList ID.
         * @summary Get Job Status
         * @param {string} listId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobStatus(listId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LookupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobStatus(listId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadListsApi.getJobStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the LeadList object.
         * @summary Get List Obj
         * @param {string} listId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getListObj(listId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeadList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getListObj(listId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadListsApi.getListObj']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Display all leads associated with the LeadList.
         * @summary Get List Of Leads
         * @param {string} listId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getListOfLeads(listId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Lead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getListOfLeads(listId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadListsApi.getListOfLeads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Display the current user\'s LeadLists.
         * @summary Get Lists
         * @param {boolean} [showHidden] Include hidden/deleted LeadLists in results
         * @param {boolean} [onlyHidden] Include only hidden/deleted LeadLists in results
         * @param {string} [search] Search for lists by name. Separate terms by a space
         * @param {number} [offset] Number of rows to skip before beginning to return rows
         * @param {number} [limit] Number of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLists(showHidden?: boolean, onlyHidden?: boolean, search?: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LeadList>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLists(showHidden, onlyHidden, search, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadListsApi.getLists']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Display the current user\'s LeadLists with total count.
         * @summary Get Lists With Count
         * @param {boolean} [showHidden] Include hidden/deleted LeadLists in results
         * @param {boolean} [onlyHidden] Include only hidden/deleted LeadLists in results
         * @param {string} [search] Search for lists by name. Separate terms by a space
         * @param {number} [offset] Number of rows to skip before beginning to return rows
         * @param {number} [limit] Number of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getListsWithCount(showHidden?: boolean, onlyHidden?: boolean, search?: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeadListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getListsWithCount(showHidden, onlyHidden, search, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadListsApi.getListsWithCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a LeadList by sending only those fields to be changed.
         * @summary Patch List
         * @param {string} listId 
         * @param {LeadList} leadList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchList(listId: string, leadList: LeadList, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeadList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchList(listId, leadList, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadListsApi.patchList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a LeadList by setting all values for the LeadList object.
         * @summary Update List
         * @param {string} listId 
         * @param {LeadList} leadList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateList(listId: string, leadList: LeadList, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeadList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateList(listId, leadList, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadListsApi.updateList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LeadListsApi - factory interface
 * @export
 */
export const LeadListsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LeadListsApiFp(configuration)
    return {
        /**
         * Create a new LeadList.
         * @summary Create List
         * @param {LeadList} leadList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createList(leadList: LeadList, options?: RawAxiosRequestConfig): AxiosPromise<LeadList> {
            return localVarFp.createList(leadList, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a LeadList. This is a soft operation. Deleted LeadLists will be marked as hidden.  Note that if delete_list raises a LeadListNotFound exception, this means that no items were found that match the criteria to identify the item to delete.  In that case, this function will raise an exception with status 404.  If, within delete_list, an error occurs while deleting the item, an exception will be thrown with status 500.  If no error is thrown, and delete_list returns a number greater than 0, the delete succeeded, and status code 204 will be returned.  The return value from this function will be None.
         * @summary Delete List
         * @param {string} listId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteList(listId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteList(listId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the job status of the provided LeadList ID.
         * @summary Get Job Status
         * @param {string} listId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobStatus(listId: string, options?: RawAxiosRequestConfig): AxiosPromise<LookupResponse> {
            return localVarFp.getJobStatus(listId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the LeadList object.
         * @summary Get List Obj
         * @param {string} listId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListObj(listId: string, options?: RawAxiosRequestConfig): AxiosPromise<LeadList> {
            return localVarFp.getListObj(listId, options).then((request) => request(axios, basePath));
        },
        /**
         * Display all leads associated with the LeadList.
         * @summary Get List Of Leads
         * @param {string} listId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListOfLeads(listId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Lead>> {
            return localVarFp.getListOfLeads(listId, options).then((request) => request(axios, basePath));
        },
        /**
         * Display the current user\'s LeadLists.
         * @summary Get Lists
         * @param {boolean} [showHidden] Include hidden/deleted LeadLists in results
         * @param {boolean} [onlyHidden] Include only hidden/deleted LeadLists in results
         * @param {string} [search] Search for lists by name. Separate terms by a space
         * @param {number} [offset] Number of rows to skip before beginning to return rows
         * @param {number} [limit] Number of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLists(showHidden?: boolean, onlyHidden?: boolean, search?: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<LeadList>> {
            return localVarFp.getLists(showHidden, onlyHidden, search, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Display the current user\'s LeadLists with total count.
         * @summary Get Lists With Count
         * @param {boolean} [showHidden] Include hidden/deleted LeadLists in results
         * @param {boolean} [onlyHidden] Include only hidden/deleted LeadLists in results
         * @param {string} [search] Search for lists by name. Separate terms by a space
         * @param {number} [offset] Number of rows to skip before beginning to return rows
         * @param {number} [limit] Number of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListsWithCount(showHidden?: boolean, onlyHidden?: boolean, search?: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<LeadListResponse> {
            return localVarFp.getListsWithCount(showHidden, onlyHidden, search, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a LeadList by sending only those fields to be changed.
         * @summary Patch List
         * @param {string} listId 
         * @param {LeadList} leadList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchList(listId: string, leadList: LeadList, options?: RawAxiosRequestConfig): AxiosPromise<LeadList> {
            return localVarFp.patchList(listId, leadList, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a LeadList by setting all values for the LeadList object.
         * @summary Update List
         * @param {string} listId 
         * @param {LeadList} leadList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateList(listId: string, leadList: LeadList, options?: RawAxiosRequestConfig): AxiosPromise<LeadList> {
            return localVarFp.updateList(listId, leadList, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LeadListsApi - object-oriented interface
 * @export
 * @class LeadListsApi
 * @extends {BaseAPI}
 */
export class LeadListsApi extends BaseAPI {
    /**
     * Create a new LeadList.
     * @summary Create List
     * @param {LeadList} leadList 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadListsApi
     */
    public createList(leadList: LeadList, options?: RawAxiosRequestConfig) {
        return LeadListsApiFp(this.configuration).createList(leadList, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a LeadList. This is a soft operation. Deleted LeadLists will be marked as hidden.  Note that if delete_list raises a LeadListNotFound exception, this means that no items were found that match the criteria to identify the item to delete.  In that case, this function will raise an exception with status 404.  If, within delete_list, an error occurs while deleting the item, an exception will be thrown with status 500.  If no error is thrown, and delete_list returns a number greater than 0, the delete succeeded, and status code 204 will be returned.  The return value from this function will be None.
     * @summary Delete List
     * @param {string} listId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadListsApi
     */
    public deleteList(listId: string, options?: RawAxiosRequestConfig) {
        return LeadListsApiFp(this.configuration).deleteList(listId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the job status of the provided LeadList ID.
     * @summary Get Job Status
     * @param {string} listId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadListsApi
     */
    public getJobStatus(listId: string, options?: RawAxiosRequestConfig) {
        return LeadListsApiFp(this.configuration).getJobStatus(listId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the LeadList object.
     * @summary Get List Obj
     * @param {string} listId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadListsApi
     */
    public getListObj(listId: string, options?: RawAxiosRequestConfig) {
        return LeadListsApiFp(this.configuration).getListObj(listId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Display all leads associated with the LeadList.
     * @summary Get List Of Leads
     * @param {string} listId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadListsApi
     */
    public getListOfLeads(listId: string, options?: RawAxiosRequestConfig) {
        return LeadListsApiFp(this.configuration).getListOfLeads(listId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Display the current user\'s LeadLists.
     * @summary Get Lists
     * @param {boolean} [showHidden] Include hidden/deleted LeadLists in results
     * @param {boolean} [onlyHidden] Include only hidden/deleted LeadLists in results
     * @param {string} [search] Search for lists by name. Separate terms by a space
     * @param {number} [offset] Number of rows to skip before beginning to return rows
     * @param {number} [limit] Number of results to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadListsApi
     */
    public getLists(showHidden?: boolean, onlyHidden?: boolean, search?: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return LeadListsApiFp(this.configuration).getLists(showHidden, onlyHidden, search, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Display the current user\'s LeadLists with total count.
     * @summary Get Lists With Count
     * @param {boolean} [showHidden] Include hidden/deleted LeadLists in results
     * @param {boolean} [onlyHidden] Include only hidden/deleted LeadLists in results
     * @param {string} [search] Search for lists by name. Separate terms by a space
     * @param {number} [offset] Number of rows to skip before beginning to return rows
     * @param {number} [limit] Number of results to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadListsApi
     */
    public getListsWithCount(showHidden?: boolean, onlyHidden?: boolean, search?: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return LeadListsApiFp(this.configuration).getListsWithCount(showHidden, onlyHidden, search, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a LeadList by sending only those fields to be changed.
     * @summary Patch List
     * @param {string} listId 
     * @param {LeadList} leadList 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadListsApi
     */
    public patchList(listId: string, leadList: LeadList, options?: RawAxiosRequestConfig) {
        return LeadListsApiFp(this.configuration).patchList(listId, leadList, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a LeadList by setting all values for the LeadList object.
     * @summary Update List
     * @param {string} listId 
     * @param {LeadList} leadList 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadListsApi
     */
    public updateList(listId: string, leadList: LeadList, options?: RawAxiosRequestConfig) {
        return LeadListsApiFp(this.configuration).updateList(listId, leadList, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LeadsApi - axios parameter creator
 * @export
 */
export const LeadsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Display details of single lead.
         * @summary Get Lead
         * @param {string} leadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLead: async (leadId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'leadId' is not null or undefined
            assertParamExists('getLead', 'leadId', leadId)
            const localVarPath = `/v2/leads/{lead_id}`
                .replace(`{${"lead_id"}}`, encodeURIComponent(String(leadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Display the leads assigned to the current user.
         * @summary Get Leads
         * @param {Array<string>} [bedrooms] Filter bedrooms by exact count or range.
         * @param {Array<string>} [bathrooms] Filter bathrooms by minimum count inclusive.
         * @param {Array<string>} [acreage] Filter acreage by exact size or range.
         * @param {Array<string>} [squareFootage] Filter square footage by exact size or range.
         * @param {Array<string>} [yearBuilt] Filter year built by exact year or range.
         * @param {Array<string>} [propertyType] Filter by property types. Can be passed multiple times.
         * @param {boolean} [favorite] Filter by previously tagged favorite.
         * @param {string} [tag] Filter leads on previously selected tags.
         * @param {string} [note] Filter leads on previously entered notes.
         * @param {boolean} [companyOwned] Filter by whether the property is owned by a company.
         * @param {boolean} [showHidden] Include hidden/deleted leads in results
         * @param {boolean} [onlyHidden] Include only hidden/deleted leads in results
         * @param {Array<string>} [listId] Restrict results to one or more lists
         * @param {number} [offset] Number of rows to skip before beginning to return rows
         * @param {number} [limit] Number of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeads: async (bedrooms?: Array<string>, bathrooms?: Array<string>, acreage?: Array<string>, squareFootage?: Array<string>, yearBuilt?: Array<string>, propertyType?: Array<string>, favorite?: boolean, tag?: string, note?: string, companyOwned?: boolean, showHidden?: boolean, onlyHidden?: boolean, listId?: Array<string>, offset?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/leads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required

            if (bedrooms) {
                localVarQueryParameter['bedrooms'] = bedrooms;
            }

            if (bathrooms) {
                localVarQueryParameter['bathrooms'] = bathrooms;
            }

            if (acreage) {
                localVarQueryParameter['acreage'] = acreage;
            }

            if (squareFootage) {
                localVarQueryParameter['square_footage'] = squareFootage;
            }

            if (yearBuilt) {
                localVarQueryParameter['year_built'] = yearBuilt;
            }

            if (propertyType) {
                localVarQueryParameter['property_type'] = propertyType;
            }

            if (favorite !== undefined) {
                localVarQueryParameter['favorite'] = favorite;
            }

            if (tag !== undefined) {
                localVarQueryParameter['tag'] = tag;
            }

            if (note !== undefined) {
                localVarQueryParameter['note'] = note;
            }

            if (companyOwned !== undefined) {
                localVarQueryParameter['company_owned'] = companyOwned;
            }

            if (showHidden !== undefined) {
                localVarQueryParameter['show_hidden'] = showHidden;
            }

            if (onlyHidden !== undefined) {
                localVarQueryParameter['only_hidden'] = onlyHidden;
            }

            if (listId) {
                localVarQueryParameter['list_id'] = listId;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Display the leads assigned to the current user with the total count.
         * @summary Get Leads With Count
         * @param {Array<string>} [bedrooms] Filter bedrooms by exact count or range.
         * @param {Array<string>} [bathrooms] Filter bathrooms by minimum count inclusive.
         * @param {Array<string>} [acreage] Filter acreage by exact size or range.
         * @param {Array<string>} [squareFootage] Filter square footage by exact size or range.
         * @param {Array<string>} [yearBuilt] Filter year built by exact year or range.
         * @param {Array<string>} [propertyType] Filter by property types. Can be passed multiple times.
         * @param {boolean} [favorite] Filter by previously tagged favorite.
         * @param {string} [tag] Filter leads on previously selected tags.
         * @param {string} [note] Filter leads on previously entered notes.
         * @param {boolean} [companyOwned] Filter by whether the property is owned by a company.
         * @param {boolean} [showHidden] Include hidden/deleted leads in results
         * @param {boolean} [onlyHidden] Include only hidden/deleted leads in results
         * @param {Array<string>} [listId] Restrict results to one or more lists
         * @param {number} [offset] Number of rows to skip before beginning to return rows
         * @param {number} [limit] Number of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadsWithCount: async (bedrooms?: Array<string>, bathrooms?: Array<string>, acreage?: Array<string>, squareFootage?: Array<string>, yearBuilt?: Array<string>, propertyType?: Array<string>, favorite?: boolean, tag?: string, note?: string, companyOwned?: boolean, showHidden?: boolean, onlyHidden?: boolean, listId?: Array<string>, offset?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/leads/with-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required

            if (bedrooms) {
                localVarQueryParameter['bedrooms'] = bedrooms;
            }

            if (bathrooms) {
                localVarQueryParameter['bathrooms'] = bathrooms;
            }

            if (acreage) {
                localVarQueryParameter['acreage'] = acreage;
            }

            if (squareFootage) {
                localVarQueryParameter['square_footage'] = squareFootage;
            }

            if (yearBuilt) {
                localVarQueryParameter['year_built'] = yearBuilt;
            }

            if (propertyType) {
                localVarQueryParameter['property_type'] = propertyType;
            }

            if (favorite !== undefined) {
                localVarQueryParameter['favorite'] = favorite;
            }

            if (tag !== undefined) {
                localVarQueryParameter['tag'] = tag;
            }

            if (note !== undefined) {
                localVarQueryParameter['note'] = note;
            }

            if (companyOwned !== undefined) {
                localVarQueryParameter['company_owned'] = companyOwned;
            }

            if (showHidden !== undefined) {
                localVarQueryParameter['show_hidden'] = showHidden;
            }

            if (onlyHidden !== undefined) {
                localVarQueryParameter['only_hidden'] = onlyHidden;
            }

            if (listId) {
                localVarQueryParameter['list_id'] = listId;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a single lead. This can be used to mark leads as hidden.
         * @summary Patch Lead
         * @param {string} leadId 
         * @param {LeadRequest} leadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchLead: async (leadId: string, leadRequest: LeadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'leadId' is not null or undefined
            assertParamExists('patchLead', 'leadId', leadId)
            // verify required parameter 'leadRequest' is not null or undefined
            assertParamExists('patchLead', 'leadRequest', leadRequest)
            const localVarPath = `/v2/leads/{lead_id}`
                .replace(`{${"lead_id"}}`, encodeURIComponent(String(leadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(leadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LeadsApi - functional programming interface
 * @export
 */
export const LeadsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LeadsApiAxiosParamCreator(configuration)
    return {
        /**
         * Display details of single lead.
         * @summary Get Lead
         * @param {string} leadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLead(leadId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Lead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLead(leadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadsApi.getLead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Display the leads assigned to the current user.
         * @summary Get Leads
         * @param {Array<string>} [bedrooms] Filter bedrooms by exact count or range.
         * @param {Array<string>} [bathrooms] Filter bathrooms by minimum count inclusive.
         * @param {Array<string>} [acreage] Filter acreage by exact size or range.
         * @param {Array<string>} [squareFootage] Filter square footage by exact size or range.
         * @param {Array<string>} [yearBuilt] Filter year built by exact year or range.
         * @param {Array<string>} [propertyType] Filter by property types. Can be passed multiple times.
         * @param {boolean} [favorite] Filter by previously tagged favorite.
         * @param {string} [tag] Filter leads on previously selected tags.
         * @param {string} [note] Filter leads on previously entered notes.
         * @param {boolean} [companyOwned] Filter by whether the property is owned by a company.
         * @param {boolean} [showHidden] Include hidden/deleted leads in results
         * @param {boolean} [onlyHidden] Include only hidden/deleted leads in results
         * @param {Array<string>} [listId] Restrict results to one or more lists
         * @param {number} [offset] Number of rows to skip before beginning to return rows
         * @param {number} [limit] Number of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLeads(bedrooms?: Array<string>, bathrooms?: Array<string>, acreage?: Array<string>, squareFootage?: Array<string>, yearBuilt?: Array<string>, propertyType?: Array<string>, favorite?: boolean, tag?: string, note?: string, companyOwned?: boolean, showHidden?: boolean, onlyHidden?: boolean, listId?: Array<string>, offset?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Lead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLeads(bedrooms, bathrooms, acreage, squareFootage, yearBuilt, propertyType, favorite, tag, note, companyOwned, showHidden, onlyHidden, listId, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadsApi.getLeads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Display the leads assigned to the current user with the total count.
         * @summary Get Leads With Count
         * @param {Array<string>} [bedrooms] Filter bedrooms by exact count or range.
         * @param {Array<string>} [bathrooms] Filter bathrooms by minimum count inclusive.
         * @param {Array<string>} [acreage] Filter acreage by exact size or range.
         * @param {Array<string>} [squareFootage] Filter square footage by exact size or range.
         * @param {Array<string>} [yearBuilt] Filter year built by exact year or range.
         * @param {Array<string>} [propertyType] Filter by property types. Can be passed multiple times.
         * @param {boolean} [favorite] Filter by previously tagged favorite.
         * @param {string} [tag] Filter leads on previously selected tags.
         * @param {string} [note] Filter leads on previously entered notes.
         * @param {boolean} [companyOwned] Filter by whether the property is owned by a company.
         * @param {boolean} [showHidden] Include hidden/deleted leads in results
         * @param {boolean} [onlyHidden] Include only hidden/deleted leads in results
         * @param {Array<string>} [listId] Restrict results to one or more lists
         * @param {number} [offset] Number of rows to skip before beginning to return rows
         * @param {number} [limit] Number of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLeadsWithCount(bedrooms?: Array<string>, bathrooms?: Array<string>, acreage?: Array<string>, squareFootage?: Array<string>, yearBuilt?: Array<string>, propertyType?: Array<string>, favorite?: boolean, tag?: string, note?: string, companyOwned?: boolean, showHidden?: boolean, onlyHidden?: boolean, listId?: Array<string>, offset?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLeadsWithCount(bedrooms, bathrooms, acreage, squareFootage, yearBuilt, propertyType, favorite, tag, note, companyOwned, showHidden, onlyHidden, listId, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadsApi.getLeadsWithCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a single lead. This can be used to mark leads as hidden.
         * @summary Patch Lead
         * @param {string} leadId 
         * @param {LeadRequest} leadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchLead(leadId: string, leadRequest: LeadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Lead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchLead(leadId, leadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadsApi.patchLead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LeadsApi - factory interface
 * @export
 */
export const LeadsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LeadsApiFp(configuration)
    return {
        /**
         * Display details of single lead.
         * @summary Get Lead
         * @param {string} leadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLead(leadId: string, options?: RawAxiosRequestConfig): AxiosPromise<Lead> {
            return localVarFp.getLead(leadId, options).then((request) => request(axios, basePath));
        },
        /**
         * Display the leads assigned to the current user.
         * @summary Get Leads
         * @param {Array<string>} [bedrooms] Filter bedrooms by exact count or range.
         * @param {Array<string>} [bathrooms] Filter bathrooms by minimum count inclusive.
         * @param {Array<string>} [acreage] Filter acreage by exact size or range.
         * @param {Array<string>} [squareFootage] Filter square footage by exact size or range.
         * @param {Array<string>} [yearBuilt] Filter year built by exact year or range.
         * @param {Array<string>} [propertyType] Filter by property types. Can be passed multiple times.
         * @param {boolean} [favorite] Filter by previously tagged favorite.
         * @param {string} [tag] Filter leads on previously selected tags.
         * @param {string} [note] Filter leads on previously entered notes.
         * @param {boolean} [companyOwned] Filter by whether the property is owned by a company.
         * @param {boolean} [showHidden] Include hidden/deleted leads in results
         * @param {boolean} [onlyHidden] Include only hidden/deleted leads in results
         * @param {Array<string>} [listId] Restrict results to one or more lists
         * @param {number} [offset] Number of rows to skip before beginning to return rows
         * @param {number} [limit] Number of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeads(bedrooms?: Array<string>, bathrooms?: Array<string>, acreage?: Array<string>, squareFootage?: Array<string>, yearBuilt?: Array<string>, propertyType?: Array<string>, favorite?: boolean, tag?: string, note?: string, companyOwned?: boolean, showHidden?: boolean, onlyHidden?: boolean, listId?: Array<string>, offset?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<Lead>> {
            return localVarFp.getLeads(bedrooms, bathrooms, acreage, squareFootage, yearBuilt, propertyType, favorite, tag, note, companyOwned, showHidden, onlyHidden, listId, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Display the leads assigned to the current user with the total count.
         * @summary Get Leads With Count
         * @param {Array<string>} [bedrooms] Filter bedrooms by exact count or range.
         * @param {Array<string>} [bathrooms] Filter bathrooms by minimum count inclusive.
         * @param {Array<string>} [acreage] Filter acreage by exact size or range.
         * @param {Array<string>} [squareFootage] Filter square footage by exact size or range.
         * @param {Array<string>} [yearBuilt] Filter year built by exact year or range.
         * @param {Array<string>} [propertyType] Filter by property types. Can be passed multiple times.
         * @param {boolean} [favorite] Filter by previously tagged favorite.
         * @param {string} [tag] Filter leads on previously selected tags.
         * @param {string} [note] Filter leads on previously entered notes.
         * @param {boolean} [companyOwned] Filter by whether the property is owned by a company.
         * @param {boolean} [showHidden] Include hidden/deleted leads in results
         * @param {boolean} [onlyHidden] Include only hidden/deleted leads in results
         * @param {Array<string>} [listId] Restrict results to one or more lists
         * @param {number} [offset] Number of rows to skip before beginning to return rows
         * @param {number} [limit] Number of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadsWithCount(bedrooms?: Array<string>, bathrooms?: Array<string>, acreage?: Array<string>, squareFootage?: Array<string>, yearBuilt?: Array<string>, propertyType?: Array<string>, favorite?: boolean, tag?: string, note?: string, companyOwned?: boolean, showHidden?: boolean, onlyHidden?: boolean, listId?: Array<string>, offset?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<LeadResponse> {
            return localVarFp.getLeadsWithCount(bedrooms, bathrooms, acreage, squareFootage, yearBuilt, propertyType, favorite, tag, note, companyOwned, showHidden, onlyHidden, listId, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a single lead. This can be used to mark leads as hidden.
         * @summary Patch Lead
         * @param {string} leadId 
         * @param {LeadRequest} leadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchLead(leadId: string, leadRequest: LeadRequest, options?: RawAxiosRequestConfig): AxiosPromise<Lead> {
            return localVarFp.patchLead(leadId, leadRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LeadsApi - object-oriented interface
 * @export
 * @class LeadsApi
 * @extends {BaseAPI}
 */
export class LeadsApi extends BaseAPI {
    /**
     * Display details of single lead.
     * @summary Get Lead
     * @param {string} leadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApi
     */
    public getLead(leadId: string, options?: RawAxiosRequestConfig) {
        return LeadsApiFp(this.configuration).getLead(leadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Display the leads assigned to the current user.
     * @summary Get Leads
     * @param {Array<string>} [bedrooms] Filter bedrooms by exact count or range.
     * @param {Array<string>} [bathrooms] Filter bathrooms by minimum count inclusive.
     * @param {Array<string>} [acreage] Filter acreage by exact size or range.
     * @param {Array<string>} [squareFootage] Filter square footage by exact size or range.
     * @param {Array<string>} [yearBuilt] Filter year built by exact year or range.
     * @param {Array<string>} [propertyType] Filter by property types. Can be passed multiple times.
     * @param {boolean} [favorite] Filter by previously tagged favorite.
     * @param {string} [tag] Filter leads on previously selected tags.
     * @param {string} [note] Filter leads on previously entered notes.
     * @param {boolean} [companyOwned] Filter by whether the property is owned by a company.
     * @param {boolean} [showHidden] Include hidden/deleted leads in results
     * @param {boolean} [onlyHidden] Include only hidden/deleted leads in results
     * @param {Array<string>} [listId] Restrict results to one or more lists
     * @param {number} [offset] Number of rows to skip before beginning to return rows
     * @param {number} [limit] Number of results to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApi
     */
    public getLeads(bedrooms?: Array<string>, bathrooms?: Array<string>, acreage?: Array<string>, squareFootage?: Array<string>, yearBuilt?: Array<string>, propertyType?: Array<string>, favorite?: boolean, tag?: string, note?: string, companyOwned?: boolean, showHidden?: boolean, onlyHidden?: boolean, listId?: Array<string>, offset?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return LeadsApiFp(this.configuration).getLeads(bedrooms, bathrooms, acreage, squareFootage, yearBuilt, propertyType, favorite, tag, note, companyOwned, showHidden, onlyHidden, listId, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Display the leads assigned to the current user with the total count.
     * @summary Get Leads With Count
     * @param {Array<string>} [bedrooms] Filter bedrooms by exact count or range.
     * @param {Array<string>} [bathrooms] Filter bathrooms by minimum count inclusive.
     * @param {Array<string>} [acreage] Filter acreage by exact size or range.
     * @param {Array<string>} [squareFootage] Filter square footage by exact size or range.
     * @param {Array<string>} [yearBuilt] Filter year built by exact year or range.
     * @param {Array<string>} [propertyType] Filter by property types. Can be passed multiple times.
     * @param {boolean} [favorite] Filter by previously tagged favorite.
     * @param {string} [tag] Filter leads on previously selected tags.
     * @param {string} [note] Filter leads on previously entered notes.
     * @param {boolean} [companyOwned] Filter by whether the property is owned by a company.
     * @param {boolean} [showHidden] Include hidden/deleted leads in results
     * @param {boolean} [onlyHidden] Include only hidden/deleted leads in results
     * @param {Array<string>} [listId] Restrict results to one or more lists
     * @param {number} [offset] Number of rows to skip before beginning to return rows
     * @param {number} [limit] Number of results to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApi
     */
    public getLeadsWithCount(bedrooms?: Array<string>, bathrooms?: Array<string>, acreage?: Array<string>, squareFootage?: Array<string>, yearBuilt?: Array<string>, propertyType?: Array<string>, favorite?: boolean, tag?: string, note?: string, companyOwned?: boolean, showHidden?: boolean, onlyHidden?: boolean, listId?: Array<string>, offset?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return LeadsApiFp(this.configuration).getLeadsWithCount(bedrooms, bathrooms, acreage, squareFootage, yearBuilt, propertyType, favorite, tag, note, companyOwned, showHidden, onlyHidden, listId, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a single lead. This can be used to mark leads as hidden.
     * @summary Patch Lead
     * @param {string} leadId 
     * @param {LeadRequest} leadRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApi
     */
    public patchLead(leadId: string, leadRequest: LeadRequest, options?: RawAxiosRequestConfig) {
        return LeadsApiFp(this.configuration).patchLead(leadId, leadRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PropertiesApi - axios parameter creator
 * @export
 */
export const PropertiesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Set favorite status of a property.  \'200 OK\' is returned instead of \'201 Created\' if the favorite already exists.
         * @summary Add Favorite
         * @param {string} propId Id of the property the favorite is attached to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFavorite: async (propId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propId' is not null or undefined
            assertParamExists('addFavorite', 'propId', propId)
            const localVarPath = `/v2/properties/{prop_id}/favorite`
                .replace(`{${"prop_id"}}`, encodeURIComponent(String(propId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a tag to a property.
         * @summary Add Tag
         * @param {string} propId 
         * @param {string} tag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTag: async (propId: string, tag: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propId' is not null or undefined
            assertParamExists('addTag', 'propId', propId)
            // verify required parameter 'tag' is not null or undefined
            assertParamExists('addTag', 'tag', tag)
            const localVarPath = `/v2/properties/{prop_id}/tags/{tag}`
                .replace(`{${"prop_id"}}`, encodeURIComponent(String(propId)))
                .replace(`{${"tag"}}`, encodeURIComponent(String(tag)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a new note to a property.
         * @summary Create Note
         * @param {string} propId 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNote: async (propId: string, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propId' is not null or undefined
            assertParamExists('createNote', 'propId', propId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createNote', 'body', body)
            const localVarPath = `/v2/properties/{prop_id}/notes`
                .replace(`{${"prop_id"}}`, encodeURIComponent(String(propId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a note from a property. This is a destructive operation.  Note that if delete_note raises a NoteNotFound exception, this means that no items were found that match the criteria to identify the item to delete.  In that case, this function will raise an exception with status 404.  If no error is thrown, and delete_note returns a number greater than 0, the delete succeeded, and status code 204 will be returned.  The return value from this function will be None.
         * @summary Delete Note
         * @param {string} propId 
         * @param {string} noteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNote: async (propId: string, noteId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propId' is not null or undefined
            assertParamExists('deleteNote', 'propId', propId)
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('deleteNote', 'noteId', noteId)
            const localVarPath = `/v2/properties/{prop_id}/notes/{note_id}`
                .replace(`{${"prop_id"}}`, encodeURIComponent(String(propId)))
                .replace(`{${"note_id"}}`, encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a tag from a property.  Note that if delete_tag raises a PropertyNotFound or TagNotFound exception, this means that no items were found that match the criteria to identify the item to delete.  In that case, this function will raise an exception with status 404.  If, within delete_tag, an error occurs while deleting the item, an exception will be thrown with status 500. If no error is thrown, the delete succeeded and status code 204 will be returned.
         * @summary Delete Tag
         * @param {string} propId 
         * @param {string} tag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTag: async (propId: string, tag: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propId' is not null or undefined
            assertParamExists('deleteTag', 'propId', propId)
            // verify required parameter 'tag' is not null or undefined
            assertParamExists('deleteTag', 'tag', tag)
            const localVarPath = `/v2/properties/{prop_id}/tags/{tag}`
                .replace(`{${"prop_id"}}`, encodeURIComponent(String(propId)))
                .replace(`{${"tag"}}`, encodeURIComponent(String(tag)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Display basic information about a property.
         * @summary Get Property
         * @param {string} propId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProperty: async (propId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propId' is not null or undefined
            assertParamExists('getProperty', 'propId', propId)
            const localVarPath = `/v2/properties/{prop_id}`
                .replace(`{${"prop_id"}}`, encodeURIComponent(String(propId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve extended information about a property.
         * @summary Get Property Details
         * @param {string} propId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPropertyDetails: async (propId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propId' is not null or undefined
            assertParamExists('getPropertyDetails', 'propId', propId)
            const localVarPath = `/v2/properties/{prop_id}/details`
                .replace(`{${"prop_id"}}`, encodeURIComponent(String(propId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the notes attached to a property.  Note that if no notes are found for the provided property ID, the return value will be an empty list.
         * @summary Get Notes
         * @param {string} propId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotes: async (propId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propId' is not null or undefined
            assertParamExists('listNotes', 'propId', propId)
            const localVarPath = `/v2/properties/{prop_id}/notes`
                .replace(`{${"prop_id"}}`, encodeURIComponent(String(propId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get tags for user.
         * @summary List User Tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserTags: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/properties/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a note.
         * @summary Patch Note
         * @param {string} propId 
         * @param {string} noteId 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchNote: async (propId: string, noteId: string, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propId' is not null or undefined
            assertParamExists('patchNote', 'propId', propId)
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('patchNote', 'noteId', noteId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('patchNote', 'body', body)
            const localVarPath = `/v2/properties/{prop_id}/notes/{note_id}`
                .replace(`{${"prop_id"}}`, encodeURIComponent(String(propId)))
                .replace(`{${"note_id"}}`, encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove favorite status of a property.
         * @summary Remove Favorite
         * @param {string} propId Id of the property the favorite is attached to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFavorite: async (propId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propId' is not null or undefined
            assertParamExists('removeFavorite', 'propId', propId)
            const localVarPath = `/v2/properties/{prop_id}/favorite`
                .replace(`{${"prop_id"}}`, encodeURIComponent(String(propId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PropertiesApi - functional programming interface
 * @export
 */
export const PropertiesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PropertiesApiAxiosParamCreator(configuration)
    return {
        /**
         * Set favorite status of a property.  \'200 OK\' is returned instead of \'201 Created\' if the favorite already exists.
         * @summary Add Favorite
         * @param {string} propId Id of the property the favorite is attached to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addFavorite(propId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Favorite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addFavorite(propId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropertiesApi.addFavorite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a tag to a property.
         * @summary Add Tag
         * @param {string} propId 
         * @param {string} tag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTag(propId: string, tag: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tag>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTag(propId, tag, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropertiesApi.addTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a new note to a property.
         * @summary Create Note
         * @param {string} propId 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNote(propId: string, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Note>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNote(propId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropertiesApi.createNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a note from a property. This is a destructive operation.  Note that if delete_note raises a NoteNotFound exception, this means that no items were found that match the criteria to identify the item to delete.  In that case, this function will raise an exception with status 404.  If no error is thrown, and delete_note returns a number greater than 0, the delete succeeded, and status code 204 will be returned.  The return value from this function will be None.
         * @summary Delete Note
         * @param {string} propId 
         * @param {string} noteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteNote(propId: string, noteId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteNote(propId, noteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropertiesApi.deleteNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a tag from a property.  Note that if delete_tag raises a PropertyNotFound or TagNotFound exception, this means that no items were found that match the criteria to identify the item to delete.  In that case, this function will raise an exception with status 404.  If, within delete_tag, an error occurs while deleting the item, an exception will be thrown with status 500. If no error is thrown, the delete succeeded and status code 204 will be returned.
         * @summary Delete Tag
         * @param {string} propId 
         * @param {string} tag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTag(propId: string, tag: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTag(propId, tag, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropertiesApi.deleteTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Display basic information about a property.
         * @summary Get Property
         * @param {string} propId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProperty(propId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertyInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProperty(propId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropertiesApi.getProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve extended information about a property.
         * @summary Get Property Details
         * @param {string} propId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPropertyDetails(propId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertyDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPropertyDetails(propId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropertiesApi.getPropertyDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the notes attached to a property.  Note that if no notes are found for the provided property ID, the return value will be an empty list.
         * @summary Get Notes
         * @param {string} propId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listNotes(propId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Note>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listNotes(propId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropertiesApi.listNotes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get tags for user.
         * @summary List User Tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUserTags(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUserTags(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropertiesApi.listUserTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a note.
         * @summary Patch Note
         * @param {string} propId 
         * @param {string} noteId 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchNote(propId: string, noteId: string, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Note>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchNote(propId, noteId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropertiesApi.patchNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove favorite status of a property.
         * @summary Remove Favorite
         * @param {string} propId Id of the property the favorite is attached to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeFavorite(propId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeFavorite(propId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropertiesApi.removeFavorite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PropertiesApi - factory interface
 * @export
 */
export const PropertiesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PropertiesApiFp(configuration)
    return {
        /**
         * Set favorite status of a property.  \'200 OK\' is returned instead of \'201 Created\' if the favorite already exists.
         * @summary Add Favorite
         * @param {string} propId Id of the property the favorite is attached to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFavorite(propId: string, options?: RawAxiosRequestConfig): AxiosPromise<Favorite> {
            return localVarFp.addFavorite(propId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a tag to a property.
         * @summary Add Tag
         * @param {string} propId 
         * @param {string} tag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTag(propId: string, tag: string, options?: RawAxiosRequestConfig): AxiosPromise<Tag> {
            return localVarFp.addTag(propId, tag, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a new note to a property.
         * @summary Create Note
         * @param {string} propId 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNote(propId: string, body: string, options?: RawAxiosRequestConfig): AxiosPromise<Note> {
            return localVarFp.createNote(propId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a note from a property. This is a destructive operation.  Note that if delete_note raises a NoteNotFound exception, this means that no items were found that match the criteria to identify the item to delete.  In that case, this function will raise an exception with status 404.  If no error is thrown, and delete_note returns a number greater than 0, the delete succeeded, and status code 204 will be returned.  The return value from this function will be None.
         * @summary Delete Note
         * @param {string} propId 
         * @param {string} noteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNote(propId: string, noteId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteNote(propId, noteId, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a tag from a property.  Note that if delete_tag raises a PropertyNotFound or TagNotFound exception, this means that no items were found that match the criteria to identify the item to delete.  In that case, this function will raise an exception with status 404.  If, within delete_tag, an error occurs while deleting the item, an exception will be thrown with status 500. If no error is thrown, the delete succeeded and status code 204 will be returned.
         * @summary Delete Tag
         * @param {string} propId 
         * @param {string} tag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTag(propId: string, tag: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTag(propId, tag, options).then((request) => request(axios, basePath));
        },
        /**
         * Display basic information about a property.
         * @summary Get Property
         * @param {string} propId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProperty(propId: string, options?: RawAxiosRequestConfig): AxiosPromise<PropertyInfo> {
            return localVarFp.getProperty(propId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve extended information about a property.
         * @summary Get Property Details
         * @param {string} propId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPropertyDetails(propId: string, options?: RawAxiosRequestConfig): AxiosPromise<PropertyDetails> {
            return localVarFp.getPropertyDetails(propId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the notes attached to a property.  Note that if no notes are found for the provided property ID, the return value will be an empty list.
         * @summary Get Notes
         * @param {string} propId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotes(propId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Note>> {
            return localVarFp.listNotes(propId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get tags for user.
         * @summary List User Tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserTags(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.listUserTags(options).then((request) => request(axios, basePath));
        },
        /**
         * Update a note.
         * @summary Patch Note
         * @param {string} propId 
         * @param {string} noteId 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchNote(propId: string, noteId: string, body: string, options?: RawAxiosRequestConfig): AxiosPromise<Note> {
            return localVarFp.patchNote(propId, noteId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove favorite status of a property.
         * @summary Remove Favorite
         * @param {string} propId Id of the property the favorite is attached to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFavorite(propId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeFavorite(propId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PropertiesApi - object-oriented interface
 * @export
 * @class PropertiesApi
 * @extends {BaseAPI}
 */
export class PropertiesApi extends BaseAPI {
    /**
     * Set favorite status of a property.  \'200 OK\' is returned instead of \'201 Created\' if the favorite already exists.
     * @summary Add Favorite
     * @param {string} propId Id of the property the favorite is attached to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertiesApi
     */
    public addFavorite(propId: string, options?: RawAxiosRequestConfig) {
        return PropertiesApiFp(this.configuration).addFavorite(propId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a tag to a property.
     * @summary Add Tag
     * @param {string} propId 
     * @param {string} tag 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertiesApi
     */
    public addTag(propId: string, tag: string, options?: RawAxiosRequestConfig) {
        return PropertiesApiFp(this.configuration).addTag(propId, tag, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a new note to a property.
     * @summary Create Note
     * @param {string} propId 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertiesApi
     */
    public createNote(propId: string, body: string, options?: RawAxiosRequestConfig) {
        return PropertiesApiFp(this.configuration).createNote(propId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a note from a property. This is a destructive operation.  Note that if delete_note raises a NoteNotFound exception, this means that no items were found that match the criteria to identify the item to delete.  In that case, this function will raise an exception with status 404.  If no error is thrown, and delete_note returns a number greater than 0, the delete succeeded, and status code 204 will be returned.  The return value from this function will be None.
     * @summary Delete Note
     * @param {string} propId 
     * @param {string} noteId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertiesApi
     */
    public deleteNote(propId: string, noteId: string, options?: RawAxiosRequestConfig) {
        return PropertiesApiFp(this.configuration).deleteNote(propId, noteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a tag from a property.  Note that if delete_tag raises a PropertyNotFound or TagNotFound exception, this means that no items were found that match the criteria to identify the item to delete.  In that case, this function will raise an exception with status 404.  If, within delete_tag, an error occurs while deleting the item, an exception will be thrown with status 500. If no error is thrown, the delete succeeded and status code 204 will be returned.
     * @summary Delete Tag
     * @param {string} propId 
     * @param {string} tag 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertiesApi
     */
    public deleteTag(propId: string, tag: string, options?: RawAxiosRequestConfig) {
        return PropertiesApiFp(this.configuration).deleteTag(propId, tag, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Display basic information about a property.
     * @summary Get Property
     * @param {string} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertiesApi
     */
    public getProperty(propId: string, options?: RawAxiosRequestConfig) {
        return PropertiesApiFp(this.configuration).getProperty(propId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve extended information about a property.
     * @summary Get Property Details
     * @param {string} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertiesApi
     */
    public getPropertyDetails(propId: string, options?: RawAxiosRequestConfig) {
        return PropertiesApiFp(this.configuration).getPropertyDetails(propId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the notes attached to a property.  Note that if no notes are found for the provided property ID, the return value will be an empty list.
     * @summary Get Notes
     * @param {string} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertiesApi
     */
    public listNotes(propId: string, options?: RawAxiosRequestConfig) {
        return PropertiesApiFp(this.configuration).listNotes(propId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get tags for user.
     * @summary List User Tags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertiesApi
     */
    public listUserTags(options?: RawAxiosRequestConfig) {
        return PropertiesApiFp(this.configuration).listUserTags(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a note.
     * @summary Patch Note
     * @param {string} propId 
     * @param {string} noteId 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertiesApi
     */
    public patchNote(propId: string, noteId: string, body: string, options?: RawAxiosRequestConfig) {
        return PropertiesApiFp(this.configuration).patchNote(propId, noteId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove favorite status of a property.
     * @summary Remove Favorite
     * @param {string} propId Id of the property the favorite is attached to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertiesApi
     */
    public removeFavorite(propId: string, options?: RawAxiosRequestConfig) {
        return PropertiesApiFp(this.configuration).removeFavorite(propId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReportApi - axios parameter creator
 * @export
 */
export const ReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add new report.
         * @summary Create Property Report
         * @param {PropertyReport} propertyReport 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReport: async (propertyReport: PropertyReport, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyReport' is not null or undefined
            assertParamExists('createPropertyReport', 'propertyReport', propertyReport)
            const localVarPath = `/v2/report/create-property-report/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(propertyReport, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportApi - functional programming interface
 * @export
 */
export const ReportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportApiAxiosParamCreator(configuration)
    return {
        /**
         * Add new report.
         * @summary Create Property Report
         * @param {PropertyReport} propertyReport 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPropertyReport(propertyReport: PropertyReport, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertyReportDb>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPropertyReport(propertyReport, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.createPropertyReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportApi - factory interface
 * @export
 */
export const ReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportApiFp(configuration)
    return {
        /**
         * Add new report.
         * @summary Create Property Report
         * @param {PropertyReport} propertyReport 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReport(propertyReport: PropertyReport, options?: RawAxiosRequestConfig): AxiosPromise<PropertyReportDb> {
            return localVarFp.createPropertyReport(propertyReport, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportApi - object-oriented interface
 * @export
 * @class ReportApi
 * @extends {BaseAPI}
 */
export class ReportApi extends BaseAPI {
    /**
     * Add new report.
     * @summary Create Property Report
     * @param {PropertyReport} propertyReport 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public createPropertyReport(propertyReport: PropertyReport, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).createPropertyReport(propertyReport, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReverseAddressApi - axios parameter creator
 * @export
 */
export const ReverseAddressApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Submit one or more addresses to create a LeadList.
         * @summary Reverse Address Lookup
         * @param {ReverseAddressRequest} reverseAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reverseAddressLookup: async (reverseAddressRequest: ReverseAddressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reverseAddressRequest' is not null or undefined
            assertParamExists('reverseAddressLookup', 'reverseAddressRequest', reverseAddressRequest)
            const localVarPath = `/v2/reverse-address`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reverseAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Preview Leads that would be returned for the same parameters when performing a reverse address lookup.
         * @summary Reverse Address Preview
         * @param {ReverseAddressRequest} reverseAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reverseAddressPreview: async (reverseAddressRequest: ReverseAddressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reverseAddressRequest' is not null or undefined
            assertParamExists('reverseAddressPreview', 'reverseAddressRequest', reverseAddressRequest)
            const localVarPath = `/v2/reverse-address/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reverseAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReverseAddressApi - functional programming interface
 * @export
 */
export const ReverseAddressApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReverseAddressApiAxiosParamCreator(configuration)
    return {
        /**
         * Submit one or more addresses to create a LeadList.
         * @summary Reverse Address Lookup
         * @param {ReverseAddressRequest} reverseAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reverseAddressLookup(reverseAddressRequest: ReverseAddressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeadList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reverseAddressLookup(reverseAddressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReverseAddressApi.reverseAddressLookup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Preview Leads that would be returned for the same parameters when performing a reverse address lookup.
         * @summary Reverse Address Preview
         * @param {ReverseAddressRequest} reverseAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reverseAddressPreview(reverseAddressRequest: ReverseAddressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reverseAddressPreview(reverseAddressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReverseAddressApi.reverseAddressPreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReverseAddressApi - factory interface
 * @export
 */
export const ReverseAddressApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReverseAddressApiFp(configuration)
    return {
        /**
         * Submit one or more addresses to create a LeadList.
         * @summary Reverse Address Lookup
         * @param {ReverseAddressRequest} reverseAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reverseAddressLookup(reverseAddressRequest: ReverseAddressRequest, options?: RawAxiosRequestConfig): AxiosPromise<LeadList> {
            return localVarFp.reverseAddressLookup(reverseAddressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Preview Leads that would be returned for the same parameters when performing a reverse address lookup.
         * @summary Reverse Address Preview
         * @param {ReverseAddressRequest} reverseAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reverseAddressPreview(reverseAddressRequest: ReverseAddressRequest, options?: RawAxiosRequestConfig): AxiosPromise<PreviewResponse> {
            return localVarFp.reverseAddressPreview(reverseAddressRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReverseAddressApi - object-oriented interface
 * @export
 * @class ReverseAddressApi
 * @extends {BaseAPI}
 */
export class ReverseAddressApi extends BaseAPI {
    /**
     * Submit one or more addresses to create a LeadList.
     * @summary Reverse Address Lookup
     * @param {ReverseAddressRequest} reverseAddressRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReverseAddressApi
     */
    public reverseAddressLookup(reverseAddressRequest: ReverseAddressRequest, options?: RawAxiosRequestConfig) {
        return ReverseAddressApiFp(this.configuration).reverseAddressLookup(reverseAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Preview Leads that would be returned for the same parameters when performing a reverse address lookup.
     * @summary Reverse Address Preview
     * @param {ReverseAddressRequest} reverseAddressRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReverseAddressApi
     */
    public reverseAddressPreview(reverseAddressRequest: ReverseAddressRequest, options?: RawAxiosRequestConfig) {
        return ReverseAddressApiFp(this.configuration).reverseAddressPreview(reverseAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UpdateContactsApi - axios parameter creator
 * @export
 */
export const UpdateContactsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This function gets a previous created list and updates it with contact informations if basic_user_new_list_name is not None the list is updated with the new name passed in.  Parameters:     - request (Request): The FastAPI request object.     - background_tasks (BackgroundTasks): The FastAPI background tasks object.     - list_id (UUID4): The ID of the LeadList to be updated.     - basic_user_new_list_name (str | None, optional): The new name for the LeadList. Defaults to None.     - user (AuthenticatedUser, optional): The authenticated user object. Defaults to None.  Returns:     - LeadList | None: The updated LeadList object or None if not found.  Raises:     - HTTPException 404: If the LeadList is not found.     - HTTPException 500: If there is a server error.
         * @summary Update Contacts
         * @param {string} listId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContacts: async (listId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listId' is not null or undefined
            assertParamExists('updateContacts', 'listId', listId)
            const localVarPath = `/v2/lead-lists/update-contacts/{list_id}`
                .replace(`{${"list_id"}}`, encodeURIComponent(String(listId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UpdateContactsApi - functional programming interface
 * @export
 */
export const UpdateContactsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UpdateContactsApiAxiosParamCreator(configuration)
    return {
        /**
         * This function gets a previous created list and updates it with contact informations if basic_user_new_list_name is not None the list is updated with the new name passed in.  Parameters:     - request (Request): The FastAPI request object.     - background_tasks (BackgroundTasks): The FastAPI background tasks object.     - list_id (UUID4): The ID of the LeadList to be updated.     - basic_user_new_list_name (str | None, optional): The new name for the LeadList. Defaults to None.     - user (AuthenticatedUser, optional): The authenticated user object. Defaults to None.  Returns:     - LeadList | None: The updated LeadList object or None if not found.  Raises:     - HTTPException 404: If the LeadList is not found.     - HTTPException 500: If there is a server error.
         * @summary Update Contacts
         * @param {string} listId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContacts(listId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeadList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContacts(listId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UpdateContactsApi.updateContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UpdateContactsApi - factory interface
 * @export
 */
export const UpdateContactsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UpdateContactsApiFp(configuration)
    return {
        /**
         * This function gets a previous created list and updates it with contact informations if basic_user_new_list_name is not None the list is updated with the new name passed in.  Parameters:     - request (Request): The FastAPI request object.     - background_tasks (BackgroundTasks): The FastAPI background tasks object.     - list_id (UUID4): The ID of the LeadList to be updated.     - basic_user_new_list_name (str | None, optional): The new name for the LeadList. Defaults to None.     - user (AuthenticatedUser, optional): The authenticated user object. Defaults to None.  Returns:     - LeadList | None: The updated LeadList object or None if not found.  Raises:     - HTTPException 404: If the LeadList is not found.     - HTTPException 500: If there is a server error.
         * @summary Update Contacts
         * @param {string} listId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContacts(listId: string, options?: RawAxiosRequestConfig): AxiosPromise<LeadList> {
            return localVarFp.updateContacts(listId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UpdateContactsApi - object-oriented interface
 * @export
 * @class UpdateContactsApi
 * @extends {BaseAPI}
 */
export class UpdateContactsApi extends BaseAPI {
    /**
     * This function gets a previous created list and updates it with contact informations if basic_user_new_list_name is not None the list is updated with the new name passed in.  Parameters:     - request (Request): The FastAPI request object.     - background_tasks (BackgroundTasks): The FastAPI background tasks object.     - list_id (UUID4): The ID of the LeadList to be updated.     - basic_user_new_list_name (str | None, optional): The new name for the LeadList. Defaults to None.     - user (AuthenticatedUser, optional): The authenticated user object. Defaults to None.  Returns:     - LeadList | None: The updated LeadList object or None if not found.  Raises:     - HTTPException 404: If the LeadList is not found.     - HTTPException 500: If there is a server error.
     * @summary Update Contacts
     * @param {string} listId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateContactsApi
     */
    public updateContacts(listId: string, options?: RawAxiosRequestConfig) {
        return UpdateContactsApiFp(this.configuration).updateContacts(listId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Return the current user\'s lookup quota.
         * @summary Get Quota
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLookupQuota: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/user/quota`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the subscription level of a user.  Args:     user_id (str): id of the user     user (AuthenticatedUser, optional): Authenticated employee  Returns:     UserSubscriptionLevel
         * @summary Get Subscription Level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionLevel: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/user/subscription-level`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get User Setting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/user/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save User Setting
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUserSettings: async (body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveUserSettings', 'body', body)
            const localVarPath = `/v2/user/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            // authentication APIKeyCookie required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * Return the current user\'s lookup quota.
         * @summary Get Quota
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLookupQuota(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QuotaApp>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLookupQuota(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getLookupQuota']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the subscription level of a user.  Args:     user_id (str): id of the user     user (AuthenticatedUser, optional): Authenticated employee  Returns:     UserSubscriptionLevel
         * @summary Get Subscription Level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubscriptionLevel(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSubscriptionLevel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubscriptionLevel(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getSubscriptionLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get User Setting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getUserSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Save User Setting
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveUserSettings(body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveUserSettings(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.saveUserSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * Return the current user\'s lookup quota.
         * @summary Get Quota
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLookupQuota(options?: RawAxiosRequestConfig): AxiosPromise<Array<QuotaApp>> {
            return localVarFp.getLookupQuota(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the subscription level of a user.  Args:     user_id (str): id of the user     user (AuthenticatedUser, optional): Authenticated employee  Returns:     UserSubscriptionLevel
         * @summary Get Subscription Level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionLevel(options?: RawAxiosRequestConfig): AxiosPromise<UserSubscriptionLevel> {
            return localVarFp.getSubscriptionLevel(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get User Setting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSettings(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getUserSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save User Setting
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUserSettings(body: object, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.saveUserSettings(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * Return the current user\'s lookup quota.
     * @summary Get Quota
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getLookupQuota(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).getLookupQuota(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the subscription level of a user.  Args:     user_id (str): id of the user     user (AuthenticatedUser, optional): Authenticated employee  Returns:     UserSubscriptionLevel
     * @summary Get Subscription Level
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getSubscriptionLevel(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).getSubscriptionLevel(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get User Setting
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getUserSettings(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).getUserSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save User Setting
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public saveUserSettings(body: object, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).saveUserSettings(body, options).then((request) => request(this.axios, this.basePath));
    }
}



